<div class="profile-dropdown-menu masthead-profile">
  <ul class="nav-dropdown-list">
    @if (hasDelegateForEmployees) {
    <li ngbDropdown class="drop-down-selector"
      [ngClass]="{ 'nav-item-dropdown': true, 'nav-item-menu': myUser.isOpen() }" #myUser="ngbDropdown">
      <a class="nav-link text-info" [attr.aria-label]="resourcestrings['Aon.Navigation.Profile.SwitchProfile']"
        href="javascript:void(0)" [attr.aria-expanded]="myUser.isOpen()" [attr.aria-haspopup]="'listbox'" role="button"
        ngbDropdownToggle (keydown.escape)="myUser.close()">
        <div class="icon-badge-container d-flex align-items-center">
          <span [ngbTooltip]="resourcestrings['Aon.Navigation.Profile.SwitchProfile']">
            {{ resourcestrings['Aon.Navigation.Profile.SwitchProfile']}}
          </span>
          @if (!myUser.isOpen()) {
          <i class="flex-grow-1 text-end aon-icon aon-menu-collapse m-l-4" aria-hidden="true"></i>
          }
          @if (myUser.isOpen()) {
          <i class="flex-grow-1 text-end aon-icon aon-angle-up m-l-4" aria-hidden="true"></i>
          }
        </div>
      </a>
      <div ngbDropdownMenu class="profile-dropdown">
        <app-masthead-delegate-employees [resourcestrings]="resourceStrings">
        </app-masthead-delegate-employees>
      </div>
    </li>
    }
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="aboutme"
        class="dropdown-item p-l-20 p-r-20">{{ resourcestrings['Aon.Navigation.AboutMe']}}</a>
    </li>
    @if (profileService.showMyBenefits) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="activebenefits"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Profile.Benefits']}}</a>
    </li>
    }
    @if (profileService.showLifeEvents) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="lifeevents"
        class="dropdown-item p-l-20 p-r-20">
        {{resourcestrings['Aon.Profile.LifeEvents']}}</a>
    </li>
    }
    @if (profileService.showSaveQuotes) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="savedquote"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Navigation.SavedQuotes']}}</a>
    </li>
    }

    @if (!profileService.hideProfileAccount) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="account"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Navigation.Account']}}</a>
    </li>
    }

    @if (profileService.showDependantsAndBeneficiaries) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="dependentsandbeneficiaries"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Profile.DependentsAndBeneficiaries']}}</a>
    </li>
    }

    @if (profileService.showDocuments) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="documents"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Profile.Documents']}}</a>
    </li>
    }

    @if (profileService.showPayments) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="payment"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Profile.Payment']}}</a>
    </li>
    }

    @if (profileService.showInsuredClaims) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="insuredclaims"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Profile.InsuredClaims']}}</a>
    </li>
    }
    @if (profileService.showMyPolicies) {
    <li>
      <a [routerLink]="[baseUrl+'/profile']" (click)="closeModal($event)" fragment="myactivepolicies"
        class="dropdown-item p-l-20 p-r-20">{{
        resourcestrings['Aon.Profile.MyPolicies']}}</a>
    </li>
    }
    <li>
      <a (click)="logOut()" class="logout dropdown-item p-l-20 p-r-20" fragment="logout" href="javascript:void(0)">{{
        resourcestrings['Aon.Navigation.Logout']}}</a>
    </li>
  </ul>
</div>